/**
 * Preview of a course for its authors (#526): without `preview=true` the player
 * applies the learner gates (enrollment, active course) and an author — who is
 * not enrolled in the draft — got an error page.
 */
export const coursePreviewPath = (courseId: number | string): string => `/course-player/${courseId}?preview=true`;
